
export const validatorPhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入手机号'))
  } else {
    let regPone = null
    let mobile = /^1(3|4|5|6|7|8|9)\d{9}$/ // 最新16手机正则
    let tel = /^(0\d{2,3}-){0,1}\d{7,8}$/ // 座机
    if (value.charAt(0) === '0') { // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
      regPone = tel
    } else {
      regPone = mobile
    }
    if (!regPone.test(value)) {
      callback(new Error('联系电话格式不对'))
    }
    callback()
  }
}

export const validatorSocialCreditCode = (rule, value, callback) => {
  const patrn = /^[0-9A-Z]+$/
  if (!value) {
    return callback(new Error('统一信用代码不能为空'))
  } else if ((value.length !== 18) || !patrn.test(value)) {
    callback(new Error('请输入正确的统一信用代码'))
  } else {
    let Ancode// 统一社会信用代码的每一个值
    let Ancodevalue// 统一社会信用代码每一个值的权重
    let total = 0
    const weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28]// 加权因子
    const str = '0123456789ABCDEFGHJKLMNPQRTUWXY'
    // 不用I、O、S、V、Z
    for (let i = 0; i < value.length - 1; i++) {
      Ancode = value.substring(i, i + 1)
      Ancodevalue = str.indexOf(Ancode)
      total = total + Ancodevalue * weightedfactors[i]
      // 权重与加权因子相乘之和
    }
    let logiccheckcode = 31 - total % 31
    if (logiccheckcode === 31) {
      logiccheckcode = 0
    }
    const str2 = '0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y'
    const arrayStr = str2.split(',')
    logiccheckcode = arrayStr[logiccheckcode]

    const checkcode = value.substring(17, 18)

    if (logiccheckcode !== checkcode) {
      callback(new Error('请输入正确的统一信用代码'))
    }
    callback()
  }
}

export const validatorIdCard = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入身份证号'))
  } else {
    let regExp = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    if (!regExp.test(value)) {
      callback(new Error('身份证号格式不对'))
    }
    callback()
  }
}
